export const verifyNIN = async (nin, phone) => {
  const response = await fetch(
     //`https://localhost:44332/api/Users/verify-nin`,
      `https://registration.labourpartynigeria.org.ng:8443/api/Users/verify-nin`,
    {
      method: "POST", // Changed from GET to POST
      headers: {
        "Content-Type": "application/json",
      },
      // Passing the data in the body as JSON
      body: JSON.stringify({
        nin: nin,
        // phoneNumber: phone
      }),
    }
  );

  // Handle errors
  if (!response.ok) {
    const errorData = await response.json();
    // Check if the API returns a 'message' or generic 'title' from the validation error
    throw new Error(errorData.message || errorData.title || "Verification failed");
  }

  return await response.json();
};